import env_dev from "./env.dev";
import env_prod from "./env.prod";
import env_stage from "./env.stage";
const env = {
    DEV: env_dev,
    PROD: env_prod,
    STAGE: env_stage
}
export default env.DEV